"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapWithTranslationContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const wrapWithTranslationContainer = (BaseComponent, wrapperProps) => {
    const WrappedComponent = () => {
        const { initialData } = wrapperProps;
        const initialI18nStore = initialData.translationResources;
        const initialLanguage = initialData.language;
        const ExtendedApp = (0, react_i18next_1.withSSR)()(BaseComponent);
        return (0, jsx_runtime_1.jsx)(ExtendedApp, { initialLanguage: initialLanguage, initialI18nStore: initialI18nStore });
    };
    return WrappedComponent;
};
exports.wrapWithTranslationContainer = wrapWithTranslationContainer;
//# sourceMappingURL=translationWrapper.js.map